import {WelcomeContent} from '../WelcomeContent';
import React from 'react';
import {Dialog} from '@priority-software/priority-style-react/dist';
import {sendMonitor} from '../../../../utils/monitoring';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    componentClasses: string;
    showSkipDialog: () => void;
    startProcess: () => void;
};

export const WelcomeDialog = ({
    isOpen,
    onClose,
    componentClasses,
    showSkipDialog,
    startProcess
}: Props) => {
    const onCloseWelcomeDialog = () => {
        sendMonitor('OnboardingWelcomeX');
        onClose();
    };
    const onSnoozeWelcomeDialog = () => {
        sendMonitor('OnboardingWelcomeLater');
        onClose();
    };
    const onStartOnBoarding = () => {
        sendMonitor('OnboardingWelcomeStart');
        startProcess();
    };
    const onSkipOnboarding = () => {
        sendMonitor('OnboardingWelcomeClose');
        showSkipDialog();
    };

    return (
        <Dialog
            zIndex={2000}
            componentClasses={componentClasses}
            isOpen={isOpen}
            onClose={onCloseWelcomeDialog}
            width={720}
            size="large"
            content={
                <WelcomeContent
                    onStartOnBoarding={onStartOnBoarding}
                    onPauseOnBoarding={onSnoozeWelcomeDialog}
                    onMessageShow={onSkipOnboarding}
                />
            }
        />
    );
};
